import type { SupportTicketComment } from "../supportTicketTypes";
import SupportTicketCommentComposer from "./supportTicketCommentComposer";
import SupportTicketCommentsList from "./supportTicketCommentsList";

/**
 * Props for {@link SupportTicketCommentsSection}.
 */
interface SupportTicketCommentsSectionProps {
  comments: SupportTicketComment[];
  onAddComment?: (comment: string, files: File[]) => Promise<boolean>;
  isAddingComment?: boolean;
}

/**
 * Comments block with heading, thread, and composer.
 *
 * @param props - Comment thread and submit handler.
 * @returns Comments section for the ticket main panel.
 */
const SupportTicketCommentsSection = ({
  comments,
  onAddComment,
  isAddingComment = false,
}: SupportTicketCommentsSectionProps) => {
  return (
    <section className="support-tickets-comments-section flex min-h-0 flex-1 flex-col">
      <div className="border-b border-primaryGray-14 px-4 py-3 text-base font-bold text-[#0F0F0F]">
        Comments
      </div>

      <SupportTicketCommentsList
        comments={comments}
        loading={isAddingComment}
      />
      <SupportTicketCommentComposer
        onAddComment={onAddComment}
        isAddingComment={isAddingComment}
      />
    </section>
  );
};

export default SupportTicketCommentsSection;
